import { css } from '@emotion/css';
import { Button, Content, Headline, TextButton } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { uiConfig } from '../../services/config';

const imageContainerStyle = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  min-height: 8rem;
  max-height: 360px;
  justify-items: center;
  justify-self: center;
  align-self: center;
  justify-content: center;
`;

const imageStyle = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
`;

const instructionStyle = css`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  font-size: 21px;
  color: black;
  font-weight: ${uiConfig.styles.fontWeights.regular};
  margin: 0 0 28px 0;
  text-align: left;
  max-lines: 3;
`;
const subtitleStyle = css`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  font-family: ${uiConfig.styles.fontFamily};
  font-weight: ${uiConfig.styles.fontWeights.regular};
  font-size: 16px;
  color: ${uiConfig.styles.colors.black};
  padding-bottom: 10px;
  text-align: left;
  padding-top: 24px;
  max-lines: 3;
`;

interface MidJourneyIntroProps {
  title: string;
  subTitle: string;
  imageSrc: string;
  buttonText: string;
  onClick?: () => void;
  skipButtonText: string;
  onSkip?: () => void;
}

export function MidJourneyIntro({
  title,
  subTitle,
  imageSrc,
  buttonText,
  skipButtonText,
  onSkip,
  onClick,
}: MidJourneyIntroProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <Content disableScrollbar>
        {onSkip && <div className={subtitleStyle}>{subTitle}</div>}
        <Headline className={instructionStyle}>{title}</Headline>
        <div className={imageContainerStyle}>
          <img
            data-cy="intro-image"
            src={imageSrc}
            alt={t('imageAlt.midJourneyIntro')}
            className={imageStyle}
          />
        </div>
      </Content>
      <div
        style={{
          padding: '24px',
          alignContent: 'center',
          justifyItems: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Button onClick={onClick}>{buttonText}</Button>
        {onSkip && <TextButton onClick={onSkip}>{skipButtonText}</TextButton>}
      </div>
    </>
  );
}
